// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2tC7r","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3LpQf"};